/*
LS - Left section TABS
*/
//#region DASHBOARD APP
export const DASHBOARD_APP_TABS = {
  MAP: 'Map',
  NETWORK: 'Network',
  RTU_HEALTH: 'RTU Health',
  COMMU_OUTAGES: 'Communication Outages',
  SLD: 'SLD',
  FAULTS: 'Faults',
  ANALOG_LOG: 'Analog Log',
  ANALOG_REALTIME_DATA: 'Analog Realtime Data',
  EVENT_LOG: 'Event Log',
  POWER_QUALITY: 'Power Quality',
  ASSET: 'Asset',
  SUBSTATION_HEALTH: 'Substation Health',
};

export const dashboardTabsSequence = [
  {
    //Left section Tabs
    name: DASHBOARD_APP_TABS.MAP,
    tabSequenceNumber: 1,
    tabKey: 3,
  },
  {
    name: DASHBOARD_APP_TABS.NETWORK,
    tabSequenceNumber: 2,
    tabKey: 1,
  },
  {
    name: DASHBOARD_APP_TABS.RTU_HEALTH,
    tabSequenceNumber: 3,
    tabKey: 2,
  },
  {
    name: DASHBOARD_APP_TABS.COMMU_OUTAGES,
    tabSequenceNumber: 4,
    tabKey: 4,
  }, //Right section Tabs
  {
    name: DASHBOARD_APP_TABS.SLD,
    tabSequenceNumber: 1,
    tabKey: 1,
  },
  {
    name: DASHBOARD_APP_TABS.FAULTS,
    tabSequenceNumber: 2,
    tabKey: 2,
  },
  {
    name: DASHBOARD_APP_TABS.ANALOG_LOG,
    tabSequenceNumber: 3,
    tabKey: 3,
  },
  {
    name: DASHBOARD_APP_TABS.ANALOG_REALTIME_DATA,
    tabSequenceNumber: 4,
    tabKey: 8,
  },
  {
    name: DASHBOARD_APP_TABS.POWER_QUALITY,
    tabSequenceNumber: 5,
    tabKey: 7,
  },
  {
    name: DASHBOARD_APP_TABS.ASSET,
    tabSequenceNumber: 6,
    tabKey: 4,
  },
  {
    name: DASHBOARD_APP_TABS.EVENT_LOG,
    tabSequenceNumber: 7,
    tabKey: 5,
  },
  {
    name: DASHBOARD_APP_TABS.SUBSTATION_HEALTH,
    tabSequenceNumber: 8,
    tabKey: 6,
  },
];
//#endregion

//#region ASSET HEALTH APP
export const ASSET_HEALTH_APP_TABS = {
  MAP_OF_ALERTS: 'Map of Alerts', //LS
  DETAILS: 'Details', //LS
  TABLE_OF_ALERTS: 'Table of Alerts',
};

export const AssetHealthAppTabsSequence = [
  {
    name: ASSET_HEALTH_APP_TABS.MAP_OF_ALERTS,
    tabSequenceNumber: 1,
    tabKey: 1,
  },
  {
    name: ASSET_HEALTH_APP_TABS.DETAILS,
    tabSequenceNumber: 2,
    tabKey: 2,
  },
  {
    name: ASSET_HEALTH_APP_TABS.TABLE_OF_ALERTS,
    tabSequenceNumber: 1,
    tabKey: 1,
  },
];

//#endregion

//#region Fault APP
export const FAULT_APP_TABS = {
  MAP_OF_ALERTS: 'Map of Alerts', //LS
  DETAILS: 'Details', //LS
  TABLE_OF_FAULTS: 'Table of Faults',
};

export const FaultAppTabsSequence = [
  {
    name: FAULT_APP_TABS.MAP_OF_ALERTS,
    tabSequenceNumber: 1,
    tabKey: 1,
  },
  {
    name: FAULT_APP_TABS.DETAILS,
    tabSequenceNumber: 2,
    tabKey: 2,
  },
  {
    name: FAULT_APP_TABS.TABLE_OF_FAULTS,
    tabSequenceNumber: 1,
    tabKey: 1,
  },
];

//#endregion

//#region EE APP
export const EE_APP_TABS = {
  MAP_OF_ALERTS: 'Map of Alerts', //LS
  DETAILS: 'Details', //LS
  TABLE_OF_ALERTS: 'Table of Alerts',
  TABLE_OF_PERFORMANCE_TRACKER: 'Table of Performance Trackers',
};
export const eeAppTabsSequence = [
  {
    name: EE_APP_TABS.MAP_OF_ALERTS,
    tabSequenceNumber: 1,
    tabKey: 1,
  },
  {
    name: EE_APP_TABS.DETAILS,
    tabSequenceNumber: 2,
    tabKey: 2,
  },
  {
    name: EE_APP_TABS.TABLE_OF_ALERTS,
    tabSequenceNumber: 1,
    tabKey: 1,
  },
  {
    name: EE_APP_TABS.TABLE_OF_PERFORMANCE_TRACKER,
    tabSequenceNumber: 2,
    tabKey: 2,
  },
];
//#endregion

export const clientsSpecificTabsAccess = {
  [DASHBOARD_APP_TABS.ASSET]: 'showAssetTab',
  [DASHBOARD_APP_TABS.SUBSTATION_HEALTH]: 'showSubstationHealthTab',
  [DASHBOARD_APP_TABS.NETWORK]: 'showNetworkTab',
  [DASHBOARD_APP_TABS.RTU_HEALTH]: 'showRTUHealthTab',
  [DASHBOARD_APP_TABS.COMMU_OUTAGES]: 'showOutageTab',
};
